export default __webpack_public_path__ + "static/s1-afecf727ce8839483a2d77dcc9156a79.jpg";